export default "__VITE_ASSET__c962364f__"